<template>
  <!-- <div class='instruction-box' v-if="isAuditing">
    <div class='slide-toggle' @click="slideToggle()">
      <div class='toggle-title'>
        <span>搜货精选+</span>
        <div class='flex' v-if="!rebateOpen">
          <div class='tag'>比价</div>
        </div>
      </div>
      <div class="detail-allow-right" :class="[rebateOpen ? 'rotate-45' : '']"></div>
    </div>
    <div class="instruction-detail"  v-if="rebateOpen">
      <div class='process-main'>
        <div class='process-tag'>
          <div class='process-left'>
            <div class='tag'>比价</div>
          </div>
          <div class='process-right'>
            <div>提供品牌正品最低价参考</div>
          </div>
        </div>
        <div class='process-tag'>
          <div class='process-left'>
            <div class='tag'>吊牌价</div>
          </div>
          <div class='process-right'>
            <div>￥{{productInfo.ProductPrice | toFixed}}</div>
          </div>
        </div>
        <div class='process-tag'>
          <div class='process-left'>
            <div class='tag'>京东最低价</div>
          </div>
          <div class='process-right'>
            <div>￥{{productInfo.SaleDiscountPrice | toFixed}}</div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <div class="instruction-box">
    <div class="slide-toggle" @click="slideToggle()">
      <div class="toggle-title">
        <span>返利流程</span>
        <div class="flex" v-if="!rebateOpen">
          <div class="tag">搜索</div>
          <div class="tag">提交</div>
          <div class="tag">返利</div>
        </div>
      </div>
      <div class="detail-allow-right" :class="[rebateOpen ? 'rotate-45' : '']"></div>
    </div>
    <div class="instruction-detail" v-if="rebateOpen">
      <div class="use-step">
        <div class="guide-arrow">
          <div class="g-icon-left">
            <div class="arrow-icon"></div>
            <div class="text">
              <span class="t_f05c61">下单后</span>
              <span>2小时内</span>
            </div>
          </div>
          <div class="g-icon-right">
            <div class="arrow-icon"></div>
            <div class="text">
              <span class="t_f05c61">收货后</span>
              <span>10分钟内</span>
            </div>
          </div>
        </div>
        <div class="guide-detail">
          <div>
            <div class="guide-icon"><span class="iconfont" :class="PLATFORM_TYPE_DETAIL[platformType].iconfont"></span></div>
            <div>
              <span>前往{{ PLATFORM_TYPE_DETAIL[platformType].collectively }}APP</span>
              <span>搜索并下单</span>
            </div>
          </div>
          <div class="gd-mid">
            <div class="guide-icon"><span class="iconfont icon-dingdan"></span></div>
            <div>
              <span>返回此页面</span>
              <span>提交订单</span>
            </div>
          </div>
          <div>
            <div class="guide-icon"><span class="iconfont icon-icon_right"></span></div>
            <div class="p_right">
              <span>返利自动到账</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rebateOpen: true
    }
  },
  props: {
    isRebateOpen: {
      type: Boolean,
      default: true
    },
    productInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    platformType: {
      type: Number,
      default: 0
    }
  },
  methods: {
    slideToggle() {
      this.rebateOpen = !this.rebateOpen
    }
  },
  watch: {
    isRebateOpen() {
      this.rebateOpen = this.isRebateOpen
    }
  },
  filters: {
    toFixed(value) {
      if (!value) {
        value = 0
      }
      return parseFloat(value).toFixed(2)
    }
  }
}
</script>

<style scoped>
.instruction-box {
  margin-top: 3%;
  background: #ffffff;
}
.instruction-box .slide-toggle {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 3% 4%;
  box-sizing: border-box;
  transition: 0.3s;
  border-bottom: 1px solid #f2f2f2;
}
.instruction-box .toggle-title {
  display: flex;
  align-items: center;
}
.instruction-box .tag {
  display: inline-block;
  border: 1px solid #f23030;
  padding: 0 15px;
  color: #f23030;
  font-size: 13px;
  border-radius: 6px;
}
.toggle-title span {
  margin-right: 20px;
  display: block;
  flex-shrink: 0;
  font-size: 15px;
}
.toggle-title .tag {
  margin-right: 10px;
  word-break: keep-all;
}
.detail-allow-right {
  border: 2px solid #c8c8cd;
  border-bottom-width: 0;
  border-left-width: 0;
  content: ' ';
  top: 50%;
  right: 20px;
  position: absolute;
  width: 5px;
  height: 5px;
  transform: translateY(-50%) rotate(135deg);
}
.rotate-45 {
  transform: rotate(-45deg);
  transition: 0.4s linear 0s;
}
.instruction-detail {
  height: auto;
  overflow: hidden;
}
/* ------------正常展现样式----------------- */
.use-step {
  padding: 3% 0;
  background: #ffffff;
}
/* 箭头图标 */
.use-step .guide-arrow {
  display: flex;
  width: calc(100% - 20px);
  padding: 3% 1%;
  align-items: center;
  height: 4em;
}
.guide-arrow > div {
  text-align: center;
  flex: 1;
}
.guide-arrow .g-icon-left {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 21%;
  margin-right: 2.5em;
  z-index: 10;
}
.guide-arrow .g-icon-right {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 10;
  margin-right: 21%;
  margin-left: 3.75em;
}
.guide-arrow .arrow-icon {
  position: absolute;
  right: -4px;
  color: #ddd;
  font-size: 12px;
  border-top: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 8px solid #ddd;
}
.guide-arrow .text {
  width: 100%;
}
.guide-arrow .text span {
  display: block;
  font-size: 13px;
  color: #999;
  line-height: 2em;
  word-break: keep-all;
}
.guide-arrow .text .t_f05c61 {
  border-bottom: 1px solid #ddd;
  color: #f05c61;
}
/* 图标、文字说明 */
.guide-detail {
  display: flex;
  width: calc(100% - 10px);
  padding: 3% 1%;
  align-items: flex-start;
  margin-top: -7em;
}
.guide-detail > div {
  flex: 1;
  position: relative;
  text-align: center;
  font-size: 13px;
}
.guide-detail > div span {
  display: block;
}
.guide-detail .gd-mid {
  flex: 2;
}
.guide-detail .guide-icon {
  width: 4em;
  height: 4em;
  line-height: 4em;
  background: #f05c61;
  border-radius: 100%;
  color: #fff;
  border: 10px solid #fff;
  margin: 0 auto 0;
  position: relative;
}
.guide-icon .iconfont {
  font-size: 20px;
}
/* ------------正常展现样式end----------------- */
/* ------------isAuditing: true 展现样式----------------- */
.process-main {
  padding: 0 4%;
}
.process-tag {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.process-tag .tag {
  margin-right: 4%;
}
.process-tag:last-child {
  margin-bottom: 0;
}
.process-left {
  word-break: keep-all;
}
.process-right {
  padding-bottom: 0;
  height: 3.5em;
  width: calc(100% - 10em);
  border-bottom: 1px solid #f2f2f2;
  font-size: 13px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.process-tag:last-child .process-right {
  border-bottom: none;
}
/* ------------isAuditing: true 展现样式end----------------- */
</style>
